import { TFunction } from "i18next";
import styles from "./styles.module.css";
import { isRTL } from 'src/utils/global';
import { GiAnvilImpact, GiLaserPrecision, GiRollingEnergy, GiSteelwingEmblem } from 'react-icons/gi';
import { MdPrecisionManufacturing, MdSettingsSuggest } from 'react-icons/md';
import { AiOutlineFieldTime } from 'react-icons/ai';
import { useTranslation } from "react-i18next";
import { Element } from "react-scroll";


const getServices = (t: TFunction) => (
    [
        {
            icon: <GiAnvilImpact />, // أيقونة تعبر عن الطي/الضغط
            title: t("services.inspection.metal_bending.title"),
            description: t("services.inspection.metal_bending.description"),
        },
        {
            icon: <GiLaserPrecision />, // أيقونة تعبر عن القص بالليزر
            title: t("services.inspection.laser_cutting.title"),
            description: t("services.inspection.laser_cutting.description"),
        },
        {
            icon: <MdPrecisionManufacturing />, // أيقونة تعبر عن اللحام/التصنيع
            title: t("services.inspection.laser_welding.title"),
            description: t("services.inspection.laser_welding.description"),
        },
        {
            icon: <GiRollingEnergy />, // أيقونة تعبر عن الدرفلة
            title: t("services.inspection.metal_rolling.title"),
            description: t("services.inspection.metal_rolling.description"),
        },
        {
            icon: <GiSteelwingEmblem />, // أيقونة تعبر عن الهياكل المعدنية
            title: t("services.inspection.custom_fabrication.title"),
            description: t("services.inspection.custom_fabrication.description"),
        },
        {
            icon: <MdSettingsSuggest />, // أيقونة تعبر عن الاستشارة الفنية
            title: t("services.inspection.industrial_consulting.title"),
            description: t("services.inspection.industrial_consulting.description"),
        },
        {
            icon: <AiOutlineFieldTime />, // أيقونة تعبر عن السرعة والوقت
            title: t("services.inspection.fast_production.title"),
            description: t("services.inspection.fast_production.description"),
        },
    ]
);

const ServicesInspection = () => {
    const { t } = useTranslation("home");

    return (
        <Element name="services" className={`${styles.services} ${isRTL() && styles.rtl}`}>
            <div className="container">
                {/* Title */}
                <h2 className={styles.title}>
                    {t("services.inspection.title", "تخصصاتنا ومنتجاتنا")}
                </h2>

                {/* Cards */}
                <div className="row g-4">
                    {getServices(t).map((service, index) => (
                        <div
                            data-aos="fade-up"
                            data-aos-delay={index}
                            data-aos-anchor-placement="top-bottom"
                            key={index}
                            className="col-12 col-md-6 col-lg-4 mx-auto" // تم إضافة col-lg-4 لجعل التصميم أفضل في الشاشات الكبيرة (3 كروت في الصف)
                        >
                            <div className={styles.card}>
                                <div className={styles.icon}>{service.icon}</div>
                                <h3 className={styles.cardTitle}>{service.title}</h3>
                                <p className={styles.description}>
                                    {service.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Element>
    );
};

export default ServicesInspection;